var _path, _mask, _path2, _rect, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.2498 8.28667V36C34.2498 37.7949 32.7947 39.25 30.9998 39.25H9C7.20507 39.25 5.75 37.7949 5.75 36V4C5.75 2.20508 7.20508 0.75 9 0.75H26.0445L34.2498 8.28667Z",
    stroke: "#D0D5DD",
    strokeWidth: 1.5
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_9950_3964",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 1H33.5V9.5H26C25.4477 9.5 25 9.05229 25 8.5V1Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 1H33.5H25ZM33.5 10.5H26C24.8954 10.5 24 9.60457 24 8.5H26H33.5V10.5ZM26 10.5C24.8954 10.5 24 9.60457 24 8.5V1H26V8.5V10.5ZM33.5 1V9.5V1Z",
    fill: "#D0D5DD",
    mask: "url(#path-2-inside-1_9950_3964)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 20,
    width: 23,
    height: 13,
    rx: 2,
    fill: "#F04438"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9827 25.24C8.9827 25.6467 8.88936 26.02 8.7027 26.36C8.51603 26.6933 8.22936 26.9633 7.8427 27.17C7.45603 27.3767 6.97603 27.48 6.4027 27.48H5.3427V30H3.6327V22.98H6.4027C6.9627 22.98 7.43603 23.0767 7.8227 23.27C8.20936 23.4633 8.49936 23.73 8.6927 24.07C8.88603 24.41 8.9827 24.8 8.9827 25.24ZM6.2727 26.12C6.59936 26.12 6.8427 26.0433 7.0027 25.89C7.1627 25.7367 7.2427 25.52 7.2427 25.24C7.2427 24.96 7.1627 24.7433 7.0027 24.59C6.8427 24.4367 6.59936 24.36 6.2727 24.36H5.3427V26.12H6.2727ZM12.5029 22.98C13.2429 22.98 13.8896 23.1267 14.4429 23.42C14.9963 23.7133 15.4229 24.1267 15.7229 24.66C16.0296 25.1867 16.1829 25.7967 16.1829 26.49C16.1829 27.1767 16.0296 27.7867 15.7229 28.32C15.4229 28.8533 14.9929 29.2667 14.4329 29.56C13.8796 29.8533 13.2363 30 12.5029 30H9.87293V22.98H12.5029ZM12.3929 28.52C13.0396 28.52 13.5429 28.3433 13.9029 27.99C14.2629 27.6367 14.4429 27.1367 14.4429 26.49C14.4429 25.8433 14.2629 25.34 13.9029 24.98C13.5429 24.62 13.0396 24.44 12.3929 24.44H11.5829V28.52H12.3929ZM21.7086 22.98V24.35H18.8486V25.83H20.9886V27.16H18.8486V30H17.1386V22.98H21.7086Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdf-icon.1bea6aad194d37c678a28645e93f3cdc.svg";
export { ForwardRef as ReactComponent };